<template>
    
        <div class="card mB-10">
            <div class="card-header text-danger">
                <h5 class="mb-0"><i class="far fa-triangle-exclamation"></i> Important note - Addons summary</h5>
            </div>
            <div class="card-body">
                <p class="mB-0">This is a summary of the current addons on the policy. When doing an amendment addons cannot be modified.</p>
            </div>
        </div>
</template>